module.exports = __webpack_public_path__ + "2d0dde5f5ce7b520e2386dfdbb1be560.svg";